import styled from 'styled-components'

export const SelectAllBarStyled = styled.button`
  display: block;
  width: 100%;
  padding: ${(props) => props.theme.typography.pxToRem(12)};
  border: none;
  cursor: pointer;
  text-align: center;
  font-weight: ${(props) => props.theme.fontWeights.semibold};
  font-size: ${(props) => props.theme.typography.pxToRem(14)};
  background-color: ${(props) => props.theme.colors.textLink};
  color: ${(props) => props.theme.colors.text.inverse};
`
